import React, { Component,PropTypes } from 'react';
import render from "react-dom";
import { Link,hashHistory } from "react-router";
import {ellaUrl} from '../../../path.config'
export default class SubsystemsyncEdit extends Component {
	constructor(props) {
		super(props);
		this.btnSubmit = this.btnSubmit.bind(this);
		this.state = {
			id: this.props.params.id,
			subsystemsync:{},
			url:ellaUrl
		};
	}
	componentDidMount() {
		var id = this.state.id;
		$.ajax({
			type: "GET",
			url:this.state.url+"/subsystemsync/toUpdate/"+id,
			contentType: "application/json;charset=UTF-8",
			success: function(data) {
				if(data.data !=null){
					console.log(JSON.stringify(data.data.subsystemsync));
				var subsystemsync = data.data.subsystemsync
			 	this.setState({
			 		subsystemsync : data.data.subsystemsync,
			 	})
			 	$("#name").val(subsystemsync.name);
			 	$("#url").val(subsystemsync.url);
			 	$("#remark").val(subsystemsync.remark);
				}
			}.bind(this),
			error: function(data) {
				console.log("Get nodeVos info error");
			}.bind(this),
		});		
	}
	btnSubmit(){
		var id = this.state.id;
		var name = $("#name").val();
		var url = $("#url").val();
		var remark = $("#remark").val();
		var data = {
			id:id,
			name:name,
			url:url,
			remark:remark
		};
		$.ajax({
			type:"POST",
			url:this.state.url+"/subsystemsync/doAddOrUpdate",
			contentType: "application/json;charset=UTF-8",
			data:JSON.stringify(data),
			success:function(data){
				if (data.code == 8001) {
					$("#success_msg").text(data.msg);
					$("#success_tip").removeClass("hidden");
					setTimeout(function() {
						$("#success_tip").addClass("hidden");
                        hashHistory.push('/ella/user/userType/userTypeIndex');
					}, 2000);
				} else {
					$("#error_msg").text(data.msg);
					$("#error_tip").removeClass("hidden");
					setTimeout(function() {
						$("#error_tip").addClass("hidden");
					}, 2000);
				}
			}.bind(this),
			error:function(){
				console.log("submit error");
			}.bind(this),
		});
	}
	render() {
		return (
			<div >
				<section className="content-header " >
			        <h1> 子系统信息管理 <small>编辑子系统信息</small> </h1>
			    </section>
			    <section className="content" >
		        <div className="box box-primary color-palette-box">
		            <div className="box-header with-border">
		               	<i className="fa fa-plus-circle"></i>
		                <h3 className="box-title">编辑子系统信息</h3>
		            </div>
		            <div className="box-body">
		                <div id={"error_tip"} className="hidden alert-tip">
		                    <div className="alert alert-danger">
		                      	<strong>Whoops!</strong>
		                        <button type="button" className="close" data-dismiss='alert'>×</button>
		                        <span id={"error_msg"}>&nbsp;提交失败.</span>
		                    </div>
		                </div> 
		             	<div id={"success_tip"} className="hidden alert-tip">
		                    <div className="alert alert-success">
		                        <button type="button" className="close" data-dismiss='alert'>×</button>
		                        <strong>Success.</strong><span id={"success_msg"}>提交成功</span>
		                    </div>
		             	</div>
		             	<form>
			             	<div className="row form-group">
			             		<label  className="multi-label control-label col-xs-1">子系统信息名称</label>
					            <div className="col-xs-4">
						            <input type="text" className="form-control" placeholder="子系统名称" id="name"/>
						        </div>
			             	</div>
			             	<div className="row form-group">
			             		<label  className="multi-label control-label col-xs-1">访问路径</label>
					            <div className="col-xs-4">
						            <input type="text" className="form-control" placeholder="访问路径" id="url"/>
						        </div>
			             	</div>
			             	<div className="row form-group">
			             		<label  className="multi-label control-label col-xs-1">备注</label>
					            <div className="col-xs-4">
						            <textarea cols="49" rows="3" id="remark" style={{padding:"6px 12px"}}></textarea>
						        </div>
			             	</div>
			             	<div className="row form-group">
			             		<div className="col-xs-1"></div>
						        <div className="col-xs-1 text-center">
						            <button className="btn btn-success" onClick={this.btnSubmit}>提交</button>
						        </div>
					            <div className="col-xs-1 text-center">
					                <Link  to = "/ella/user/subsystemsync/subsystemsyncIndex" className="btn btn-danger btn-md">
		                        		返回
		                    		</Link>
					            </div>
					        </div> 
		             	</form>
		        	</div>
				</div>
				</section>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./modules/ella/user/subsystemsync/subsystemsyncEdit.js